import styled from 'styled-components'

import {ErrorText, StyledInput} from '../input/Input.styled'

export {ErrorText}

export const DOBFieldContainer = styled.div`
  width: 100%;
`

export const DOBFieldsWrapper = styled.fieldset<{$required?: boolean}>`
  border: 1px solid
    ${({theme, $required}) =>
      $required ? theme.colors.inputBorderRequired : theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  margin: 0;
  padding: 0 ${({theme}) => theme.spacing.md};
  min-width: 0;
  min-height: ${({theme}) => theme.height.input.normal};
  display: flex;
  align-items: center;

  &:disabled {
    opacity: 0.6;
  }
`

export const DOBFieldsRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const DOBSeparator = styled.span`
  flex-shrink: 0;
  padding: 0 ${({theme}) => theme.spacing.xs};
  font-size: ${({theme}) => theme.fontSize.lg};
  line-height: ${({theme}) => theme.lineHeight.lg};
  color: ${({theme}) => theme.colors.grey.grey500};
  user-select: none;
`

export const DOBPartInput = styled(StyledInput)<{$wide?: boolean}>`
  flex: ${({$wide}) => ($wide ? '1.6 1 0' : '1 1 0')};
  min-width: 0;
  padding: 15px 0;
  text-align: center;
`
